:host {
  display: block;
}

:where(button) {
  all: unset;
  display: flex;
  width: 100%;
  cursor: pointer;
}

*,
::after,
::before {
  box-sizing: border-box;
}